// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IUi5","content":"styles_content__WpJ-p","row":"styles_row__3Nktr","footer":"styles_footer__3Rm9C","phraseLength":"styles_phraseLength__l0Oxl"};